import axios from 'axios';
import store from '@/vuex/store';
import router from '../routes/protectedRoute';
import { message } from 'ant-design-vue';

const appAxios = axios.create({ baseURL: process.env.VUE_APP_API_ENDPOINT, });

appAxios.interceptors.request.use((config) => {
    const token = store.state.auth.jwt_token;
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        config.headers["Accept-Language"] =  store.state.i18n.i_lang == 'en' ? 'en-US,en;' : 'tr,en-US;';
    }
    return config;
});

appAxios.interceptors.response.use(
    response => response,
    error => {
        if (error.response.status === 401) {
            store.dispatch('logOut');
            router.push({ name: 'login' });
        } else if (error.response.status === 403){
            message.error(store.state.i18n.i_lang == 'tr' ? 'Yetkisiz İşlem' : 'Unauthorized Operation');
        }
    }
);

export default appAxios;
